module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [(_vm.isBoolean) ? _c('form-switch', {
    attrs: {
      "errors": _vm.errors,
      "model": "plan",
      "name": _vm.name,
      "value": _vm.value
    },
    model: {
      value: (_vm.rules[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.rules, _vm.name, $$v)
      },
      expression: "rules[name]"
    }
  }) : _c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "plan",
      "name": _vm.name,
      "value": _vm.value
    },
    model: {
      value: (_vm.rules[_vm.name]),
      callback: function($$v) {
        _vm.$set(_vm.rules, _vm.name, $$v)
      },
      expression: "rules[name]"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1626bdac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/plans/PlanRuleListItem.vue
// module id = 1823
// module chunks = 0